/**
 * Определяем, запущены ли мы как PWA.
 *
 * Логика:
 *   1. Если в URL есть "?standalone=true" → считаем, что это PWA.
 *   2. Если на клиенте (есть window):
 *      - Проверяем display-mode: (standalone / fullscreen / minimal-ui)
 *      - Проверяем navigator.standalone (iOS Safari)
 *
 * @param {Object} [options]
 * @param {string} [options.url] - URL (или path) с query (например, context.route.fullPath или req.url в Nuxt)
 * @returns {boolean}
 */
export function isPWA(options = {}) {
  const { url = '' } = options

  // 1. На сервере или в универсальном коде - проверяем query "?standalone=true"
  if (url.includes('standalone=true')) {
    return true
  }

  // 2. Если мы на клиенте:
  if (typeof window !== 'undefined') {
    // (a) Проверяем несколько display-mode
    if (window.matchMedia) {
      const mqStandalone = window.matchMedia('(display-mode: standalone)').matches
      const mqFullscreen = window.matchMedia('(display-mode: fullscreen)').matches
      const mqMinimalUi = window.matchMedia('(display-mode: minimal-ui)').matches
      if (mqStandalone || mqFullscreen || mqMinimalUi) {
        return true
      }
    }

    // (b) Старый iOS Safari-способ
    if (typeof navigator !== 'undefined' && navigator.standalone) {
      return true
    }
  }

  // Если ни один из признаков не сработал
  return false
}
